import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ClientTemplateMergeFieldSettingId = Brand<number, 'ClientTemplateMergeFieldSettingId'>;
export const ClientTemplateMergeFieldSettingId = createBranded<ClientTemplateMergeFieldSettingId>();
